import React from "react";
import EventCheck from "../components/EventCheck";
import Header from "../pages/Header";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  root: {
    height: "100%",
    width: "100%",
    marginLeft: "auto",
    marginRight: "auto",
    paddingLeft: 10,
    paddingRight: 10,
  },
  checkRoot: { height: "calc(100% - 14%)" },
  checkRootBox: {
    maxWidth: 600,
    marginTop: 0,
    marginBottom: 0,
    marginLeft: "auto",
    marginRight: "auto",
    paddingLeft: 15,
    paddingRight: 15,
    paddingBottom: 10,
    paddingTop: 10,
    fontSize: 14,

    height: "100%",
  },
  "@media screen and (min-width:600px)": {
    root: {
      maxWidth: 600,
      paddingLeft: "1%",
      paddingRight: "1%",
    },
    checkRootBox: {
      marginTop: 0,
      marginBottom: 0,
      marginLeft: "auto",
      marginRight: "auto",
      paddingLeft: 50,
      paddingRight: 50,
      paddingTop: 40,
      paddingBottom: 100,
      height: "100%",
    },
  },
});
function EventCheckContainer({ match }) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Header title="특판 가격 조회" />
      <div className={classes.checkRoot}>
        <div className={classes.checkRootBox}>
          <EventCheck partcode={match.params.partcode}></EventCheck>
        </div>
      </div>
    </div>
  );
}
export default EventCheckContainer;
